<template>
	<div>
		<el-table :data="formatData" :row-style="showRow" v-bind="$attrs" class="table" :header-cell-style="{background:'#f8fafb',color: '#303140'}">
			<el-table-column v-if="columns.length===0" width="150">
				<template slot-scope="scope">
					<span v-for="space in scope.row._level" :key="space" class="ms-tree-space" />
					<i class="el-icon-edit" v-if="index==3" @click="setting(scope.row)"></i>
					<span v-if="iconShow(0,scope.row)" class="tree-ctrl" @click="toggleExpanded(scope.$index)">
						<i v-if="!scope.row._expanded" class="el-icon-plus" />
						<i v-else class="el-icon-minus" />
					</span> {{ scope.$index }}
				</template>
			</el-table-column>
			<el-table-column v-for="(column, index) in columns" v-else :key="column.value" :label="column.text" :min-width="index == 3 ? 10:25"
			 :align="index == 3 ?'center':'left'">
				<template slot-scope="scope">
					<!-- Todo -->
					<!-- eslint-disable-next-line vue/no-confusing-v-for-v-if -->
					<span v-for="space in scope.row._level" v-if="index === 0" :key="space" class="ms-tree-space" />
					<span v-if="iconShow(index,scope.row)" class="tree-ctrl" @click="toggleExpanded(scope.$index)">
						<i v-if="!scope.row._expanded" class="el-icon-caret-right" style="color: #606266" />
						<i v-else class="el-icon-caret-bottom" style="color: #606266" />
					</span>
					<span v-if="index == 2" class="modify">
						<i v-if="!scope.row.userName" @click="onmodify(scope.row)" class="el-icon-plus" style="font-size: 12px; font-weight: bolder; color: #6669e3;margin-right: 5px;cursor: pointer"></i>
						<span v-if="v" v-for=" (v,k) in scope.row.userName != null ? scope.row.userName.split(','):[]" :key="k">{{v}}
							<span style="color: #9293a1;cursor: pointer" class="el-icon-close" @click="deleteOrgPeop(scope.row,k)"></span></span>
						<!--<span v-for="(v,k) in  scope.row.toString().split(',')" :key="k">-->
						<!--{{v}}            <span  style="color: #9293a1;cursor: pointer" class="el-icon-close"></span>-->

						<!--</span>-->
						<!--{{ scope.row[column.value]}}-->
						<!--<span v-if="scope.row[column.value] "-->
						<!--style=" background-color:#888888;color: white;font-size: 12px;margin: 0px 3px ;padding: 4px;border-radius: 3px"-->
						<!--v-for="(v,k) in scope.row[column.value]"-->
						<!--:key="k">{{v}}-->
						<!--&lt;!&ndash;<el-input v-show="false" v-model="telephone"></el-input>&ndash;&gt;-->

						<!--<i style="color: white;cursor: pointer" class="el-icon-close" @click="deletpe(k)"></i>-->
						<!--</span>-->


					</span>
					<span v-if="index != 2 && index != 3">
						<!-- <el-checkbox v-if="index == 0" @change="changespan(scope.row)" :checked="scope.row.checked"></el-checkbox> -->
						<!--<router-link v-if="column.link == true && scope.row.parentId != '0'" :to="{path: '/organizationlist/organization/details', query: {id: scope.row.id}}"
						 tag="a" class="link" replace>-->
							{{scope.row[column.value]}}
						<!--</router-link>-->
						<!--<span v-if="scope.row.parentId == '0' && column.link == true"> {{scope.row[column.value]}}</span>-->
						<!--<span v-if="index == 1">{{scope.row[column.value]}}</span>-->
					</span>
					<div class="menu1" v-if="index == 3 && scope.row.parentId != '0'">
						<span class="option"></span>
						<el-dropdown @command="handleCommand" placement="bottom" size="small">
							<span class="el-dropdown-link menu">
								<span></span>
								<i>操作</i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="{flag: 1, row: scope.row}">新增组织</el-dropdown-item>
								<el-dropdown-item :command="{flag: 2, row: scope.row}">编辑组织</el-dropdown-item>
<!--								<el-dropdown-item :command="{flag: 3, row: scope.row}">合并组织</el-dropdown-item>-->
								<el-dropdown-item :command="{flag: 4, row: scope.row}">删除组织</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</template>
			</el-table-column>
			<slot />
		</el-table>
	</div>
</template>
<script>
	import treeToArray from "./eval";

	export default {
		name: "TreeTable",
		data() {
			return {
				selectarr: [],
			}
		},
		props: {
			/* eslint-disable */
			data: {
				selectIds: [],
				type: [Array, Object],
				required: true
			},
			columns: {
				type: Array,
				default: () => []
			},
			evalFunc: Function,
			evalArgs: Array,
			expandAll: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			// 格式化数据源
			formatData: function() {
				let tmp;
				if (!Array.isArray(this.data)) {
					tmp = [this.data];
				} else {
					tmp = this.data;
				}
				const func = this.evalFunc || treeToArray;
				const args = this.evalArgs ?
					Array.concat([tmp, this.expandAll], this.evalArgs) : [tmp, this.expandAll];
				return func.apply(null, args);
			}
		},
		methods: {
			
			deleteOrgPeop(row, k) {
				let name = row.userName.split(',')
				name.splice(k, 1)
				let id = row.userId.split(',')
				id.splice(k, 1)
				row.userName = name.toString()
				row.userId = id.toString()
				this.$emit('deleOrgList', name, id, row.id)
			},
			deletpe(index) {
				this.selectIds.splice(index, 1)
				this.selectList.splice(index, 1)
				// this.orgLists.splice(index, 1)

			},
			onmodify(val) {
				this.$emit('onmodifyCharge', val)
			},
			handleCommand(command) {
				this.$emit("handleCommand", command)
			},
			 showRow(row) {
        const show = (row.row.parent ? (row.row.parent._expanded && row.row.parent._show) : true);
        row.row._show = show;
        return show ? {animation:'treeTableShow 1s','-webkit-animation':'treeTableShow 1s'} :{display:'none'}
      },
			// 切换下级是否展开
			toggleExpanded: function(trIndex) {
				const record = this.formatData[trIndex];
			
				record._expanded = !record._expanded;
			},
			// 图标显示
			iconShow(index, record) {
				return index === 0 && record.childs && record.childs.length > 0;
			},
			changespan(v) {
				if (v.childs != null) {
					v.childs.forEach((x) => {
						x.checked = true;
					})
					
				}
			},
			addselect(id) {
				this.selectarr.push(id);
			}
		}
	};
</script>
<style src="../../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../../assets/css/common/operating.less" scoped lang="less"></style>
<style src="../../../assets/css/common/table.less" scoped lang="less"></style>
<style rel="stylesheet/css">
	@keyframes treeTableShow {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	@-webkit-keyframes treeTableShow {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}
</style>

<style scoped>
	.table .add {
		border: 1px solid;
	}

	.modify {
		display: flex;
		align-items: center;
	}

	/* .modify i {
    width: 18px;
    height: 18px;
    display: block;
    background-image: url(../../../assets/img/organization03.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 10px;
    margin-left: 5px;
    cursor: pointer;
  } */

	/*.modify i:hover {*/
	/*background-image: url(../../../assets/img/rename_b.png);*/
	/*}*/

	.ms-tree-space {
		position: relative;
		top: 1px;
		display: inline-block;
		font-style: normal;
		font-weight: 400;
		line-height: 1;
		width: 18px;
		height: 14px;
	}

	.ms-tree-space::before {
		content: "";
	}

	.processContainer {
		width: 100%;
		height: 100%;
	}

	table td {
		line-height: 26px;
	}

	.tree-ctrl {
		position: relative;
		cursor: pointer;
		color: #dcdfe6;
		margin-left: -18px;
	}

	.link {
		color: #6669e3;
		cursor: pointer;
	}

	.el-table th>.cell {
		position: relative;
		word-wrap: normal;
		text-overflow: ellipsis;
		vertical-align: middle;
		width: 450px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
</style>
